import api from '../../../services/api'

export const getReport = (reportId) => api.get(`/reports/${reportId}`)
export const deleteReport = (reportId) => api.delete(`/reports/${reportId}`)
export const createReport = (payload) => api.post('/reports', payload)
export const updateReportFeedback = (reportId, payload) => api.put(`/reports/${reportId}/feedback`, payload)
export const getReportHeaders = (params) => api.get('/reports/headers', { params })
export const getAvailableReportTypes = (reportOn) => api.get('/reports/available-types', { params: { reportOn } })
export const getReportFeedbackHistory = (params) => api.get('/reports/feedback-history', { params })
export const getReportCoveragePeriod = (params) => api.get('/reports/coverage-period', { params })
export const getReportWritingStatuses = () => api.get('/reports/writing-statuses')
